import Service from '@/helpers/adminService'

export default {

    login(params) {
        return Service().post('admin/login', params);
    },
    logout() {
        return Service().post('admin/logout');
    },
    me() {
        return Service().get('admin/me');
    },
}
